<div class="h-screen w-screen flex flex-col justify-center items-center overflow-hidden">
  <app-logo  class="w-[200px] animate-bounce"></app-logo>
  <h1 class="text-2xl termina-regular text-center">Sorry, this questionnaire is unavailable</h1>
    <p class="font-montserrat mt-[6px] max-w-[90%] sm:max-w-[70%] md:max-w-[50%] text-center">
        It is likely that the invite link you used to access the questionnaire is expired.
        If you think this is an error, please contact us at <a class="underline" href="mailto:admin@kekeno.tech">questionnaire&#64;kekeno.tech</a>
    </p>
</div>